import React from 'react';
import * as z from 'zod/v3';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslation } from 'react-i18next';

export default function useDepositForm(defaultValues) {
  const { t } = useTranslation();

  const schema = React.useMemo(() => {
    return z.union([
      z.object({
        firstName: z.string().nonempty({ message: t('common.requiredFieldFirstName') }),
        lastName: z.string().nonempty({ message: t('common.requiredFieldLastName') }),
        postalCode: z.string().nonempty({ message: t('common.requiredFieldPostalCode') }),
        cardNumber: z
          .any()
          .refine((value) => Boolean(value), { message: t('common.requiredFieldCardNumber') }),
        cardExpiry: z
          .any()
          .refine((value) => Boolean(value), { message: t('common.requiredFieldCardExpiry') }),
        cardCvc: z
          .any()
          .refine((value) => Boolean(value), { message: t('common.requiredFieldCardCode') }),
        // amount: z.string().nonempty({ message: t('common.requiredFieldAmount') }),
        amount: z
          .string()
          .nonempty({ message: t('common.requiredFieldAmount') })
          .refine((val) => parseInt(val, 10) >= 1, {
            message: t('common.requiredFieldSplitAmount'),
          }),
        type: z.string(),
        email: z
          .string()
          .email({ message: t('common.invalidFormatEmail') })
          .optional()
          .or(z.literal('')),
        terms: z.boolean().refine((val) => val, { message: t('common.requiredFieldTerms') }),
        preferred: z.boolean(),
        stripeElement: z.any(),
        stripe: z.any(),
      }),
      z.object({
        paymentMethodId: z.string().nonempty({ message: t('common.requiredFieldFirstName') }),
        // amount: z.string().nonempty({ message: t('common.requiredFieldAmount') }),
        amount: z
          .string()
          .nonempty({ message: t('common.requiredFieldAmount') })
          .refine((val) => parseInt(val, 10) >= 1, {
            message: t('common.requiredFieldSplitAmount'),
          }),
        type: z.string(),
        email: z
          .string()
          .email({ message: t('common.invalidFormatEmail') })
          .optional()
          .or(z.literal('')),
        terms: z.boolean().refine((val) => val, { message: t('common.requiredFieldTerms') }),
      }),
    ]);
  }, [t]);

  return useForm({
    resolver: zodResolver(schema),
    defaultValues,
    shouldUnregister: true,
  });
}
